<!-- 报告库 新增 sqm -->
<template>
  <ComponentRohsReport :kindType="data.kindType" :getData="data.getData" v-if="data.getData.supplyCode" @submitBtn="submit" @backBtn="routerBack"
    :subLoading="data.subLoading" v-loading="data.pageLoading"></ComponentRohsReport>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import ComponentRohsReport from "../ComponentRohsReport"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmAdd',
    getData:{},
    subLoading:false,
    keepalivestatus:0,
    pageLoading:false,
  })
  const routerBack = () => {
    console.log('返回')
    proxy.$router.back()
  }
  const submit = (val) => {
    console.log(val)
    data.pageLoading = true
    data.subLoading = true
    proxy.$http({
      url:'/base/newrohs/rohsReportSubmit',
      method:'post',
      data:{
        ...val,
        fixConfig:true,
        submitPerson:data.trueName,
        reportDate:proxy.time(val.reportDate)+' 00:00:00',
        expriryTime:proxy.time(val.expriryTime)+' 23:59:59',
        testReportNumberOld: val.testReportNumberOld ? val.testReportNumberOld.toString() : undefined
      }
    }).then((res=>{
      if(res.data.code == '0' && res.data.data == 'success'){
        proxy.success({
          message: h_i18n('fbd2495eab4cb34b3a6eedc8b0c5fed4'),
          title: h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            routerBack()
          }
        });
      }else{
        proxy.info(res.data.msg || h_i18n('6de920b4e4e08b261cda928d9beefab4'))
      }
    })).catch(err=>{

    }).finally(()=>{
      data.pageLoading = false
      data.subLoading = false
    })
  }

  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmAdd'
      data.conformityDeclarationsId = route.query.conformityDeclarationsId ?  route.query.conformityDeclarationsId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  (route.query.trueName || route.query.nickName) : ''
      data.getData.userName = route.query.userName ?  (route.query.userName||route.query.trueName) : ''
      data.getData.trueName = route.query.trueName ?  (route.query.trueName||route.query.userName) : ''
    }    
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
  onActivated(() => {
    if (data.keepalivestatus == 0) {
      console.log("首次打开");
      data.keepalivestatus ++
    } else {
      proxy.postThisPageHeight();
      // console.log("操作完之后打开");
    }
  })
  onDeactivated(() => {
    // console.log("keepalive-deactivated页面关闭时触发");
  })
</script>

<style>

</style>